import { WebClientListResourceFetcher } from '~src/commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { ServerApiMapper } from '~src/ts/helpers/ServerModelHelper';
import { IPublishedConnectionTableInfo } from '~src/ts/models/IPublishedConnectionTableInfo';
import { FieldValuesQuery } from '~src/ts/resources/FieldValuesQuery';
import { IListResource } from '~src/ts/resources/Resource';
import { ResourceQuery } from '~src/ts/resources/ResourceQuery';
import { GetFieldValuesRequest } from '~src/ts/ServerApi/requests/GetFieldValuesRequest';
import { GetPublishedConnectionTablesRequest } from '~src/ts/ServerApi/requests/GetPublishedConnectionTablesRequest';

export class PublishedConnectionTablesResource implements IListResource<IPublishedConnectionTableInfo> {

  private listFetcher = new WebClientListResourceFetcher(GetPublishedConnectionTablesRequest, ServerApiMapper.publishedConnectionTables);
  private fieldValuesFetcher = new WebClientListResourceFetcher(GetFieldValuesRequest, ServerApiMapper.fieldValues);

  public all(): ResourceQuery<IPublishedConnectionTableInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public valuesForField(field: string): FieldValuesQuery {
    return new FieldValuesQuery(this.fieldValuesFetcher, field, 'publishedConnectionTable');
  }
}

export const PublishedConnectionTables = new PublishedConnectionTablesResource();
